var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegramSquare = function SvgTelegramSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#29A9EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#29A9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.96243 11.7354C9.72052 10.1831 12.2265 9.15967 13.4804 8.66521C17.0604 7.25343 17.8043 7.00818 18.2892 7.00009C18.3959 6.99831 18.6343 7.02336 18.7887 7.14219C18.9192 7.24252 18.955 7.37805 18.9722 7.47318C18.9894 7.56831 19.0108 7.785 18.9938 7.95433C18.7998 9.88695 17.9603 14.5769 17.5332 16.7415C17.3525 17.6574 16.9967 17.9645 16.6522 17.9945C15.9036 18.0599 15.3351 17.5255 14.6101 17.0749C13.4755 16.3697 12.8345 15.9308 11.7332 15.2427C10.4604 14.4475 11.2855 14.0104 12.0108 13.2961C12.2006 13.1092 15.4991 10.2647 15.5629 10.0067C15.5709 9.9744 15.5783 9.85411 15.503 9.79059C15.4276 9.72707 15.3163 9.74879 15.236 9.76606C15.1223 9.79055 13.3097 10.9264 9.79841 13.1736C9.28392 13.5085 8.81791 13.6717 8.40039 13.6632C7.9401 13.6538 7.05469 13.4164 6.39648 13.2136C5.58916 12.9648 4.94752 12.8332 5.00339 12.4107C5.03249 12.1906 5.35217 11.9655 5.96243 11.7354Z",
    fill: "white"
  })));
};
export default SvgTelegramSquare;